import { render, staticRenderFns } from "./RoadTripCard.vue?vue&type=template&id=40930df4&lang=pug&"
import script from "./RoadTripCard.vue?vue&type=script&lang=js&"
export * from "./RoadTripCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports